<template>
  <BusinessProductsBlock
    v-if="(data.contentList ?? []).length"
    :class="{
      'osk-home-blocks-hselection': true,
      'osk-home-blocks-hselection_noSlider': noSlider,
    }"
    :title="data.title"
    :products="products"
    :is-seller-hidden="isSellerHidden"
    :show-more-link="link"
    chapter="product_collection"
    :chapter-id="data.id"
    use-swiper-analytics
    :analytics="analytics"
  />
</template>

<script lang="ts" setup>
import { PrimaryContentDTO, PrimaryPageProductDTO } from '~/restAPI/data-contracts';
import { IOptions } from '~/types/analytics';

const props = defineProps<{
  data: PrimaryContentDTO
}>();

const products = computed(() => (props.data.contentList ?? []) as PrimaryPageProductDTO[]);
const isSellerHidden = computed(() => (props.data.additionalData?.isSellerHidden ?? false));
const noSlider = computed(() => products.value.length < 4);

const link = computed(() => genSPALink(props.data.additionalData?.jumpLink));

const analytics = computed<IOptions>(() => ({
  chapter: props.data.contentType,
  chapter_index: props.data.chapterIndex,
  segment_id: props.data.segmentId,
  id_chapter: props.data.id,
}));
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-home-gender-page_isJournalMode {
  .osk-home-gender-page__wrapper + .osk-home-blocks-hselection {
    margin-top: -26px;

    @include media-query(lg-and-up) {
      margin-top: 0;

      &.osk-home-blocks-hselection_noSlider {
        margin-top: -58px;
      }
    }
  }

  .osk-blocks-text-controls_only-image + .osk-home-blocks-hselection {
    margin-top: -26px;

    @include media-query(lg-and-up) {
      margin-top: 0;

      &.osk-home-blocks-hselection_noSlider {
        margin-top: -58px;
      }
    }
  }

  .osk-home-blocks-hselection {
    .osk-product-card__card-icon,
    .osk-product-card__card-top {
      display: none;
    }

    .osk-products-block__footer {
      display: block;
      padding: 24px 16px 0;

      @include media-query(lg-and-up) {
        display: none;
      }

      .osk-products-block__button {
        height: 44px;
        line-height: 44px;
        width: 100%;
      }
    }
  }

  .osk-blocks-text-controls_no-image + .osk-home-blocks-hselection {
    margin-top: -18px;

    @include media-query(lg-and-up) {
      margin-top: 0;
    }
  }

  .osk-home-blocks-hselection {
    .osk-product-card__yandex-split {
      display: none;
    }
  }
}
</style>
